var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNaturalSandwichWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#F5F5F5",
    id: "outline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m491.062 56.609a7.979 7.979 0 0 0 -3.062-.59l-96-.019a79.451 79.451 0 0 0 -65.042 33.406 80.025 80.025 0 0 0 -94.558 70.594h-64.4a8 8 0 0 0 -8 8v82.083a56.383 56.383 0 0 0 -17.513 19.8 56.006 56.006 0 0 0 -72.608 72.608 55.927 55.927 0 0 0 -24.692 73.009l-23.433 23.432a10 10 0 0 0 7.076 17.068h427.17a40 40 0 0 0 40-40v-352a8 8 0 0 0 -4.938-7.391zm-407.748 383.391 368-368h17.372l-368 368zm68.686-144a40.007 40.007 0 0 1 73.914-21.228l-13.228 13.228h-4.686v4.686l-19.314 19.314h-4.686v4.686l-13.228 13.228a40.114 40.114 0 0 1 -18.772-33.914zm160-192a64.068 64.068 0 0 1 16.507 2.159 8 8 0 0 0 8.883-3.548 64.038 64.038 0 0 1 84.11-23.42l-80.814 80.809h-92.168a64.081 64.081 0 0 1 63.482-56zm-136 72h148.686l-87.259 87.259a55.959 55.959 0 0 0 -61.427-20.918zm-94 146a39.982 39.982 0 0 1 55.1-37.033 55.875 55.875 0 0 0 1.884 29.033h-.984v16h9.529a56.093 56.093 0 0 0 11.73 11.427l-17.832 17.832a56.069 56.069 0 0 0 -11.427-11.73v-9.529h-16v.984a55.875 55.875 0 0 0 -29.033-1.884 40.04 40.04 0 0 1 -2.967-15.1zm14 30a40.116 40.116 0 0 1 33.914 18.772l-13.228 13.228h-4.686v4.686l-19.314 19.314h-4.686v4.686l-13.228 13.228a40.007 40.007 0 0 1 21.228-73.914zm-41.859 77.173a56.051 56.051 0 0 0 9.118 8.254l-2.573 2.573h-17.373zm69.173 10.827 356.686-356.687v332.687a24.027 24.027 0 0 1 -24 24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m434.343 298.343-16 16a8 8 0 0 0 11.314 11.314l16-16a8 8 0 0 0 -11.314-11.314z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m405.657 338.343a8 8 0 0 0 -11.314 0l-56 56a8 8 0 0 0 11.314 11.314l56-56a8 8 0 0 0 0-11.314z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m434.343 234.343-96 96a8 8 0 0 0 11.314 11.314l96-96a8 8 0 0 0 -11.314-11.314z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m314.343 354.343-40 40a8 8 0 0 0 11.314 11.314l40-40a8 8 0 0 0 -11.314-11.314z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m234.343 370.343-24 24a8 8 0 0 0 11.314 11.314l24-24a8 8 0 1 0 -11.314-11.314z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m434.343 170.343-168 168a8 8 0 0 0 11.314 11.314l168-168a8 8 0 0 0 -11.314-11.314z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m418.343 378.343-16 16a8 8 0 0 0 11.314 11.314l16-16a8 8 0 0 0 -11.314-11.314z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m114 290h16v16h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m160 288h16v16h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m90 314h16v16h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m184 264h16v16h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m88 360h16v16h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m64 384h16v16h-16z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaturalSandwichWhite);
export default __webpack_public_path__ + "static/media/natural-sandwich-white.d45c26520a2acfd9fb926a22729751c2.svg";
export { ForwardRef as ReactComponent };